module.exports = __webpack_public_path__ + "img/ic_car.307415b8.svg";